<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Vehicle was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Vehicle - {{ this.vehicle.registration }}</h1>
    <app-audit-line [data]='this.vehicle'></app-audit-line>
    <!-- <form> -->
    <app-tabs>
      <app-tab title='Vehicle Details'>
        <app-vehicle-form [vehicle]='this.vehicle'></app-vehicle-form>
      </app-tab>

      <app-tab title='Workshop Details'>
        <app-vehicledetail-form [vehicleDetails]='this.vehicle.detail' [vehicle]='this.vehicle' [inspectionAssignments]='this.inspectionAssignments' [edit]='false'></app-vehicledetail-form>
      </app-tab>

      <app-tab title='Asset Details'>
        <app-asset-form [vehicle]='this.vehicle' [formSettings]='this.formSettings' [linkedAssets]='this.linkedAssets'></app-asset-form>
      </app-tab>

      <app-tab title='Inspections'>
        <app-vehicle-inspections-tab [vehicleId]='this.vehicle.id' [registration]='this.vehicle.registration'></app-vehicle-inspections-tab>
      </app-tab>
    </app-tabs>
    <button class="btn btn-success" (click)='save()'>Save</button>&nbsp;
    <button type="button" class="btn btn-danger" routerLink='/vehicles'>Cancel</button>
  <!-- </form> -->
</div>
</div>
